const es = {
    APP_NAME: 'Pagos Judiciales',
    HOME: 'Inicio',
    LOGIN: 'Iniciar sesión',
    CANCEL: 'Cancelar',
    PLEASE_WAIT: 'Por favor aguarde',
    LOADING: 'Cargando',
    ACCEPT: 'Aceptar',
    CLOSE: 'Cerrar',
    LOAD_MORE: 'Cargar más',
    LOGOUT: 'Cerrar sesión',
    LOAD_MORE_RECORDS: 'Cargar más',
    DELETE: 'Eliminar',
    PAYMENTS: {
        CREATE: 'Nuevo Pago',
        CHECKOUT: 'Finalizar Pagos',
        CURRENCY: '$',
        TICKET: 'Boleta de Pago',
        INFO: 'Información',
        DATA: 'Datos de Pago',
        SAVE: 'Agregar pago',
        BRANCH: 'Pagar en Sucursal',
        ONLINE: 'Pagar Online',
        TOTAL: 'Total a pagar',
        ONLINE_PAYMENT: 'Pago Online'
    },

    ERRORS: {
        SERVER_CONN: 'Error al conectarse al servidor'
    },

    LOADINGS: {
        DELETE: 'Eliminando',
        SAVE: 'Guardando',
        DATA: 'Cargando datos',
        PROCESSING: 'Procesando información'
    },

    CONFIRMATION: {
        PAYMENT_DELETE: 'Eliminar boleta de pago?',
        PAYMENT: 'Está seguro que desea realizar el pago?',
        BRANCH_PAYMENT: 'Confirmar PAGO EN SUCURSAL?',
        ONLINE_PAYMENT: 'Confirmar PAGO ONLINE?',
    },

    SUBMESSAGES: {
        PAYMENT_DELETE: 'No podrá deshacer la operación'
    },

    SELECT: {
        JURISDICTION: 'Seleccione el Fuero',
        JURISDICTIONS: 'Todos los fueros',
        PAYMENT_TYPES: 'Todos los tipos',
        PAYMENT_STATES: 'Todos los estados'
    },

    FIELDS: {
        ID: 'Id',
        LOT_ID: 'Lote ID',
        DATE: 'Fecha',
        AMOUNT: 'Monto',
        PAYMENT_DATE: 'Fecha de Pago',
        DESCRIPTION: 'Descripción',
        PROCEEDING: 'Expediente',
        TYPE: 'Tipo',
        TYPE_VOUCHER: 'Tipo/Comprobante',
        PAYMENT_TYPE: 'Tipo Pago',
        PAYMENT_METHOD: 'Método Pago',
        COVER: 'Carátula',
        LOT_STATE: 'Estado Lote',
        CLOSE_DATE: 'Fecha cierre',
        NUMBER: 'No. Expt.',
        STATE: 'Estado',
        ACTION: 'Acción',
        TOTAL: 'Total',
        VOUCHER: 'Comprobante'
    },

    ACTIONS: {
        LEY_6059: 'Boletas Ley 6059',
        NEW: 'Nuevo',
        CHECKOUT: 'Finalizar pagos',
        SAVED: 'La boleta de pago fue generada correctamente.',
        PAID_OUT: 'Pagar'
    },
};

export default es;